
export default {
  name: "pagination",
  props: {
    num: Number,
    limit: Number,
    currentPage: Number,
    onchange: Function,
  },
  methods: {
    handleCurrentChange(current) {
      const href = window.location.href;
      let newHref;
      if (href.includes("/page-")) {
        newHref = href.replace(/\/page-\d+/, `/page-${current}`);
      } else {
        newHref = `${href}/page-${current}`;
      }
      window.open(newHref, "_self");
    },
  },
};
